import React, { Component } from 'react';
import moment from 'moment';

import { defaultSorter, dateSorter } from './Helpers';
import UserModel from './UserModel'

import { Table, Tooltip, Row, Col, Statistic } from 'antd';

class UrbioticaMessagesTable extends Component {

  state = {
    children: []
  }
  expandedRowRender(record) {
    return (
      <div>
        <Row style={{ marginBottom: 20 }}>
          <Col span={3}>
            <Statistic
              formatter={(value) => { return value; }}
              title="Latitude"
              value={record.latitude} />
          </Col>
          <Col span={3}>
            <Statistic
              formatter={(value) => { return value; }}
              title="Longitude"
              value={record.longitude} />
          </Col>
          <Col span={3}>
            <Statistic
              formatter={(value) => { return value; }}
              title="ProjectID"
              value={record.projectid} />
          </Col>
          <Col span={3}>
            <Statistic
              formatter={(value) => { return value;}}
              title="OrganismID"
              value={record.organismid} />
          </Col>
          <Col span={2}>
            <Statistic
              formatter={(value) => { return value; }}
              title="Unit"
              value={record.unit} />
          </Col>
          <Col span={4}>
            <Statistic
              formatter={(value) => { return value; }}
              title="lStamps"
              value={record.lstamps} />
          </Col>
          <Col span={2}>
            <Statistic
              formatter={(value) => { return value; }}
              title="PomDesc"
              value={record.pomdesc} />
          </Col>
          <Col span={1}>
            <Statistic
              formatter={(value) => { return value; }}
              title="ZoneID"
              value={record.zoneid} />
          </Col>
        </Row>
        <Row>
          <Col span={3}>
            <Statistic
              formatter={(value) => { return value; }}
              title="AssetID"
              value={record.assetid} />
          </Col>
          <Col span={2}>
            <Statistic
              formatter={(value) => { return value; }}
              title="Pom"
              value={record.pom} />
          </Col>
          <Col span={4}>
            <Statistic
              formatter={(value) => { return value; }}
              title="TZ"
              value={record.tz} />
          </Col>
          <Col span={3}>
            <Statistic
              formatter={(value) => { return value; }}
              title="ProductType"
              value={record.producttype} />
          </Col>
          <Col span={2}>
            <Statistic
              formatter={(value) => { return value; }}
              title="Tags"
              value={record.tags} />
          </Col>
        </Row>
      </div >
    );
  }

  columns = [{
    title: 'ElementID',
    dataIndex: 'elementid',
    key: 'elementid',
    width: 30,
  }, {
    title: 'Typ zprávy',
    dataIndex: 'phenomenonid',
    key: 'phenomenonid',
    width: 50,
    filters: [{
      text: 'vehicle_ctrl',
      value: 'vehicle_ctrl',
    }, {
      text: 'vehicle',
      value: 'vehicle',
    }],
    onFilter: (value, record) => record.phenomenonid === value,
  }, {
    title: 'Occ',
    dataIndex: 'measures',
    key: 'measures',
    width: 50,
  }, {
    title: 'Časová značka',
    dataIndex: 'stamps',
    key: 'stamps',
    width: 200,
    defaultSortOrder: 'descend',
    sorter: (a, b) => dateSorter(a.stamps, b.stamps),
    render: (text, record) => {
      return moment(text).format('L LTS');
    }
  }]

  render() {
    return (
      <Table
        size='small'
        rowKey={this.props.rowKey ? this.props.rowKey : '_id'}
        loading={this.props.loading ? this.props.loading : false}
        columns={this.columns}
        dataSource={this.props.data}
        expandedRowRender={this.expandedRowRender.bind(this)}
          style={{ border: '0px' }}
        pagination={{
          showSizeChanger: true,
          defaultPageSize: localStorage.getItem('table_pageSize') !== undefined
            ? parseInt(localStorage.getItem('table_pageSize'))
            : 10,
          onShowSizeChange: (current, size) => {
            localStorage.setItem('table_pageSize', size);
          }
        }}
        style={{ border: '0px' }} />
    );
  }
}

export default UrbioticaMessagesTable;


// WEBPACK FOOTER //
// ./src/components/UrbioticaMessagesTable.js